
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from 'ui-component/extended/Chip';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { updateFilters } from 'actions/planner-filters';
import { FilterIcon } from './AdvancedFilters/filterContext';

const EXCLUDE_KEYS = ['sortBy', 'posts', 'bio', 'category', 'ids']
const NON_CANCELABLE_KEYS = ['budget', 'maxPricePerCreator', 'megaBudget', 'macroBudget', 'microBudget', 'nanoBudget']


function camelCaseToPhrase(camelCaseStr) {
  // Replace capital letters with space followed by the lowercase letter
  try{
    if(!isNaN(camelCaseStr) || !isNaN(parseFloat(camelCaseStr))) return camelCaseStr
    const result = camelCaseStr.replace(/([A-Z])/g, ' $1');
    // Capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
  } catch(e) {
    console.log("Error in camelCaseToPhrase", camelCaseStr, e);
    return camelCaseStr;
  }
}


const AppliedFilters = ({ v2 }) => {
  const dispatch = useDispatch();
  const plannerFilters = useSelector((state) => state.plannerFilters);


  const filters = useMemo(() => {
    const filterValues = {};

    Object.keys(plannerFilters).forEach(key => {
      if(!plannerFilters[key]) return;
      if (EXCLUDE_KEYS.includes(key)) return;
      if (plannerFilters[key] === null) return;
      if(key === 'platform' && plannerFilters[key] === 'instagram') return;
      filterValues[key] = plannerFilters[key];
    });

    return filterValues;

  }, [plannerFilters]);

  const handleDelete = (key) => {
    dispatch(updateFilters(key, null, true));
  };
  


  return Object.keys(filters).length > 0 ? <Grid item xs={12} md={12}>
      <Grid container marginTop={'10px'} spacing={1} alignItems={'center'}>
        {Object.keys(filters).length > 0 && <Grid item>
          <Typography variant='h5' fontWeight={700} fontSize={'0.8rem'}>
            Applied Filters:
          </Typography>
        </Grid>}
        {Object.keys(filters).map(key => {
          const value = filters[key];
          const displayValue = Array.isArray(value) ? value.join(', ') : camelCaseToPhrase(value);
          const phrase = camelCaseToPhrase(key);
          const deletable = !NON_CANCELABLE_KEYS.includes(key);

          if (v2) {
            return (
              <Grid item key={key}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    height: 30,
                    padding: deletable ? '0 6px 0 10px' : '0 12px',
                    borderRadius: 999,
                    background: '#fff',
                    border: '1px solid #e3e6ee',
                    boxShadow: '0 1px 2px rgba(17,25,54,0.04)',
                  }}
                >
                  <FilterIcon title={phrase} sx={{ fontSize: 15, mr: 0 }} />
                  <span style={{ fontSize: 12, fontWeight: 600, color: '#8a93a6' }}>{phrase}</span>
                  <span style={{ fontSize: 12.5, fontWeight: 700, color: '#1f2433', textTransform: 'capitalize' }}>
                    {displayValue}
                  </span>
                  {deletable && (
                    <span
                      onClick={() => handleDelete(key)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 18,
                        height: 18,
                        borderRadius: '50%',
                        background: '#eef1f8',
                        cursor: 'pointer',
                      }}
                    >
                      <CloseRoundedIcon sx={{ fontSize: 13, color: '#6b7280' }} />
                    </span>
                  )}
                </span>
              </Grid>
            );
          }

          return (<Grid item key={key}>
              <Chip
                variant='outlined'
                chipcolor='secondary'
                label={`${camelCaseToPhrase(key)} = ${displayValue}`}
                sx={{
                  '& .MuiChip-label': {fontSize: '0.7rem', fontWeight: 700},
                  '& .MuiChip-deleteIcon': {height: '15px', width: '15px'},
                  height: '25px',
                }}
                {...(NON_CANCELABLE_KEYS.includes(key) ? {} : {onDelete: () => handleDelete(key)})}
              />
          </Grid>)
        })}
      </Grid>
    </Grid> : <></>
}

export default AppliedFilters;